/**
 * The scene name rule (spec 018, shared by spec 021): trimmed, at most 255
 * characters; an empty result is no name (the caller keeps the old one).
 */

/** The longest scene name (characters). */
export const SCENE_NAME_MAX_LENGTH = 255;

/** The name as stored, or '' when nothing is left after trimming. */
export function normaliseSceneName(name: string): string {
  return name.trim().slice(0, SCENE_NAME_MAX_LENGTH).trim();
}
